const isValidImage = (url) => {
    return new Promise((resolve, reject) => {
        var testImage = new Image();

        testImage.onload = () => {
            resolve(true);
        };
        testImage.onerror = () => {
            resolve(false);
        };

        testImage.src = url;
    });
};

export { isValidImage };
